"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchClient = void 0;
const fetch_service_1 = require("./fetch.service");
class FetchClient {
  constructor() {
    this.baseUrl = '';
    this.options = {
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache'
    };
    this.fetch = new fetch_service_1.FetchService();
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(errorHandler) {
    this.fetch.handleError = errorHandler;
  }
  appendToken(token) {
    this.options.headers = Object.assign(Object.assign({}, this.options.headers), {
      authorization: token
    });
  }
  appendLogger(logService) {
    this.fetch.logger = logService;
  }
  get(endpoint = '', queryValues = '', options = this.options) {
    return this.fetch.http(this.baseUrl + '/' + endpoint + (queryValues ? '/' + queryValues : ''), this.buildRequestObject('GET', options));
  }
  post(endpoint = '',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data, options = this.options) {
    return this.fetch.http(this.baseUrl + '/' + endpoint, this.buildRequestObject('POST', options, data));
  }
  put(endpoint = '',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data, options = this.options) {
    return this.fetch.http(this.baseUrl + '/' + endpoint, this.buildRequestObject('PUT', options, data));
  }
  patch(endpoint = '',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data, options = this.options) {
    return this.fetch.http(this.baseUrl + '/' + endpoint, this.buildRequestObject('PATCH', options, data));
  }
  delete(endpoint = '', queryValues = '', options = this.options,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data) {
    return this.fetch.http(this.baseUrl + '/' + endpoint + (queryValues ? '/' + queryValues : ''), this.buildRequestObject('DELETE', options, data));
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  buildRequestObject(methodName, options, data) {
    const requestObject = Object.assign(Object.assign({}, options), {
      method: methodName
    });
    if (data) {
      requestObject.body = JSON.stringify(data);
    }
    return requestObject;
  }
}
exports.FetchClient = FetchClient;
